import React from "react";
import Reception from "../assets/img/reception.png";

const NewRegistration = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-[#f0f4ff]">
      <div className="flex flex-col md:flex-row bg-white p-10 rounded-lg shadow-lg">
        {/* Image Section */}
        <div className="flex justify-center mb-6 md:mb-0 md:mr-10">
          <img
            src={Reception}
            alt="Illustration of a person at a reception desk"
            className="w-64 h-auto"
          />
        </div>

        {/* Form Section */}
        <div className="w-full md:w-96">
          <h2 className="text-2xl font-bold text-blue-600 mb-6">
            New Registration
          </h2>
          <form className="space-y-4">
            {/* Name Inputs */}
            <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
              <input
                type="text"
                placeholder="First Name"
                className="w-full md:w-1/2 p-2 border border-blue-400 rounded"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="w-full md:w-1/2 p-2 border border-blue-400 rounded"
              />
            </div>

            {/* Contact Inputs */}
            <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
              <input
                type="text"
                placeholder="Mobile No."
                className="w-full md:w-1/2 p-2 border border-blue-400 rounded"
              />
              <input
                type="email"
                placeholder="Email"
                className="w-full md:w-1/2 p-2 border border-blue-400 rounded"
              />
            </div>

            {/* Address Input */}
            <input
              type="text"
              placeholder="Address"
              className="w-full p-2 border border-blue-400 rounded"
            />

            {/* Purpose of Visit */}
            <input
              type="text"
              placeholder="Purpose of visit"
              className="w-full p-2 border border-blue-400 rounded"
            />

            {/* Remark Input */}
            <input
              type="text"
              placeholder="Remark"
              className="w-full p-2 border border-blue-400 rounded"
            />

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full p-2 bg-blue-600 text-white rounded"
            >
              Sign up
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewRegistration;
